/*eslint-disable*/
import React from "react";
// react components for routing our app without refresh
import { Link } from "react-router-dom";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Tooltip from "@material-ui/core/Tooltip";

// @material-ui/icons
import { GavelTwoTone, PinDropTwoTone, CardMembershipTwoTone, Event } from "@material-ui/icons";

// core components
import Button from "components/CustomButtons/Button.jsx";
import LoginModal from "components/LoginModal/LoginModal.jsx";

import headerLinksStyle from "assets/jss/westmorland-lodge-44/components/headerLinksStyle.jsx";

function HeaderLinks({ ...props }) {
  const { classes } = props;
  return (
    <List className={classes.list}>
      <ListItem className={classes.listItem}>
        <Button
          component={Link} 
          to="/location"
          color="transparent"
          className={classes.navLink}
        >
          <PinDropTwoTone className={classes.icons} /> Find Us
        </Button>
      </ListItem>
      <ListItem className={classes.listItem}>
        <Button
          component={Link} 
          to="/calendar"
          color="transparent"
          className={classes.navLink}
        >
          <Event className={classes.icons} /> Calendar
        </Button>
      </ListItem>
      <ListItem className={classes.listItem}>
        <Button
          href="https://www.grandlodgeofnb.ca/"
          color="transparent"
          target="_blank"
          className={classes.navLink}
        >
          <GavelTwoTone className={classes.icons} /> Grand Lodge of NB
        </Button>
      </ListItem>
    </List>
  );
}

export default withStyles(headerLinksStyle)(HeaderLinks);



// WEBPACK FOOTER //
// ./src/components/Header/HeaderLinks.jsx